import { initialUserData } from "../../contexts/AuthContext";
import { TStore } from "../../hooks/useService";
import { cookieUrl } from "../../utils/apiHelper";
import { POST, respond } from "../Helpers";
import {
  TLoginData,
  TLoginService,
  TLogoutData,
  TLogoutService,
  TSendOtpService,
  TVerifyAuthData,
  TVerifyAuthService,
  TVerifyOtpData,
  TVerifyOtpService,
} from "./types";
import Cookie from "universal-cookie";

const cookies = new Cookie();

// Verify token -----------------
export const verifyAuth: TVerifyAuthService = () => {
  return async (store: TStore) => {
    const { setAuthState, setUser } = store.authStore;
    const { data, error } = await POST<TVerifyAuthData>(
      "/verifyAuth",
      {},
      true
    );

    if (error === null) {
      // localStorage.setItem("user", JSON.stringify(data?.user));
      setUser(data?.user!)
      return respond(data, null);
    }

    setAuthState({ sessionId: "" });
    setUser(initialUserData)
    cookies.remove("sessionId");
    return respond(null, error);
  };
};

// Send OTP --------------------
export const sendOtp: TSendOtpService = (phone) => {
  return async (store: TStore) => {
    const { error } = await POST("/sendOtp", { mobileNumber: phone });

    if (error === null) return respond({ sent: true }, null);
    else return respond(null, error);
  };
};

// verify otp -----------------------
export const verifyOtp: TVerifyOtpService = (params) => {
  return async (store: TStore) => {
    const { phone, otp } = params;
    const body = { mobileNumber: phone, otp };
    const { data, error } = await POST<TVerifyOtpData>("/verifyOtp", body);
    return respond(data, error);
  };
};

// Login -----------------------
export const login: TLoginService = (params) => {
  return async (contexts: TStore) => {
    const { setAuthState, setUser } = contexts.authStore;
    const { phone, otp } = params;
    const body = { mobileNumber: phone, otp };

    const { data, error } = await POST<TLoginData>("/login", body);

    if (error !== null) return respond(null, error);

    const { sessionId, user } = data!;
    setAuthState({ sessionId });
    setUser(user)
    cookies.set("sessionId", sessionId, { domain: cookieUrl(), path: "/", secure: true });
    // localStorage.setItem("user", JSON.stringify(user));
    return respond(data, null);
  };
};

// Logout --------------------------------------
export const logout: TLogoutService = () => {
  return async (store: TStore) => {
    const { setAuthState, setUser } = store.authStore;
    const { error, data } = await POST<TLogoutData>("/logout", {}, true);

    if (error !== null) return respond(null, error);

    setAuthState({ sessionId: "" });
    setUser(initialUserData)
    cookies.remove("sessionId");
    return respond(data, null);
  };
};
